export function base64UrlDecode(raw: string) {
  let base64 = raw.replace(/-/g, '+').replace(/_/g, '/');
  while (base64.length % 4) {
    base64 += '=';
  }
  return window.atob(base64);
}
